
import React from 'react';
import { Link } from 'react-router-dom';
import uniLogo from '../images/logo-uniempleo-blanco.png';
import { useLanguage } from '../i18n/LanguageContext';

export function Footer() {
	const { t } = useLanguage();
	return (
		<footer className="site-footer" style={{ background: '#171d36', color: '#fff', paddingTop: 40 }}>
			<div className="container">
				<div className="row">
					<div className="col-md-4 mb-4">
						<img src={uniLogo} width="180" className="mb-3" alt="UNIEMPLEO" />
						<p style={{ fontSize: 15, opacity: 0.85 }}>
							{t('footer.description')}
						</p>
					</div>
					<div className="col-md-2 mb-4">
						<h6 className="text-uppercase mb-3" style={{ letterSpacing: 1, fontWeight: 600 }}>{t('footer.usefulLinks')}</h6>
						<ul className="list-unstyled">
							<li><a href="https://unicaribe.edu.do/politica-de-privacidad" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', opacity: 0.9 }}>{t('footer.privacyPolicy')}</a></li>
							<li><a href="https://unicaribe.edu.do/politica-de-cookies" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', opacity: 0.9 }}>{t('footer.cookiesPolicy')}</a></li>
							<li><a href="https://unicaribe.edu.do/terminos-y-condiciones" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', opacity: 0.9 }}>{t('footer.termsAndConditions')}</a></li>
							<li><Link to="/faq" style={{ color: '#fff', opacity: 0.9 }}>{t('footer.faq')}</Link></li>
						</ul>
					</div>
					<div className="col-md-2 mb-4">
						<h6 className="text-uppercase mb-3" style={{ letterSpacing: 1, fontWeight: 600 }}>{t('footer.resources')}</h6>
						<ul className="list-unstyled">
							<li><a href="https://unicaribe.edu.do/mesa-de-ayuda" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', opacity: 0.9 }}>{t('footer.helpDesk')}</a></li>
							<li><a href="https://unicaribe.edu.do/blackboard" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', opacity: 0.9 }}>{t('footer.blackboard')}</a></li>
							<li><a href="https://correo.unicaribe.edu.do/" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', opacity: 0.9 }}>{t('footer.mail')}</a></li>
							<li><a href="https://unicaribe.edu.do/conecta" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', opacity: 0.9 }}>{t('footer.conecta')}</a></li>
						</ul>
					</div>
					<div className="col-md-2 mb-4">
						<h6 className="text-uppercase mb-3" style={{ letterSpacing: 1, fontWeight: 600 }}>{t('footer.consult')}</h6>
						<ul className="list-unstyled">
							<li>
								<a href="https://unicaribe.edu.do/oferta-academica" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', opacity: 0.9 }}>{t('footer.academicOffer')}</a>
							</li>
							<li>
								<a href="https://unicaribe.edu.do/calendario-academico" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', opacity: 0.9 }}>{t('footer.academicCalendar')}</a>
							</li>
							<li>
								<a href="https://unicaribe.edu.do/diario-unicaribeno" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', opacity: 0.9 }}>{t('footer.unicaribeno')}</a>
							</li>
							<li>
								<a href="https://unicaribe.edu.do/solicitudes-academicas" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', opacity: 0.9 }}>{t('footer.academicRequests')}</a>
							</li>
						</ul>
					</div>
					<div className="col-md-2 mb-4">
						<h6 className="text-uppercase mb-3" style={{ letterSpacing: 1, fontWeight: 600 }}>{t('footer.contact')}</h6>
						<ul className="list-unstyled" style={{ fontSize: 15 }}>
							<li><a href="mailto:uniempleo@unicaribe.edu.do" style={{ color: '#fff', opacity: 0.9 }}>{t('footer.emailContact')}</a></li>
							<li><a href="tel:+18096161616" style={{ color: '#fff', opacity: 0.9 }}>{t('footer.phoneContact')}</a></li>
							<li style={{ opacity: 0.9 }}>{t('footer.addressContact')}</li>
						</ul>
						<div className="mt-3">
							<a href="https://www.facebook.com/UnicaribeOnline" target="_blank" rel="noopener noreferrer" className="me-2" style={{ color: '#fff', fontSize: 20, marginRight: 10 }}><i className="fa fa-facebook"></i></a>
							<a href="https://www.instagram.com/unicaribeonline" target="_blank" rel="noopener noreferrer" className="me-2" style={{ color: '#fff', fontSize: 20, marginRight: 10 }}><i className="fa fa-instagram"></i></a>
							<a href="https://www.linkedin.com/school/universidad-del-caribe-dominican-republic" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', fontSize: 20 }}><i className="fa fa-linkedin"></i></a>
						</div>
					</div>
				</div>
				<div className="footer-bottom text-center pt-3 pb-2" style={{ borderTop: '1px solid #444', marginTop: 20, fontSize: 14, opacity: 0.8 }}>
					© {new Date().getFullYear()} UNIEMPLEO - Universidad del Caribe. {t('footer.rights')}
				</div>
			</div>
		</footer>
	);
}